import { FIBERS, FIBER_KO } from '../vocab';
import { Icon } from './Icon';

/**
 * 소재 필터 (계획서 U4 · 루브릭 R3-2) — 섬유 칩(폴리에스터 · 스판덱스 …) + 건수, 여럿 고르면 「모두 든 원단」.
 * 전체 원단은 목록 `material=a,b` · `facets.material`, 원단 검색은 `filters.materials` · 검색 응답 `facets.material`
 * (2026-10-18 서버 — 예전 검색은 글자 포함 material_contains 하나뿐이라 건수를 못 붙였다). 두 화면이 같은 칩 · 같은 뜻이다.
 * 단가 상한은 PriceFilter.tsx(지연 청크) — operator 이상에게만 그린다.
 */
export interface FacetCount { value: string; count: number }

/** 예전에 저장한 검색의 글자 조건(material_contains: 'poly') → 섬유 키로 되읽기용 — 서버 FIBERS 정규식의 대표 표기 */
export const FIBER_TEXT: Record<string, string> = {
  polyester: 'poly', spandex: 'span', nylon: 'nylon', cotton: 'cotton', rayon: 'rayon',
  wool: 'wool', linen: 'linen', acrylic: 'acrylic', metallic: 'metal',
};

/** 주소의 섬유 목록(material=a,b) — 서버가 모르는 값은 버린다(400 을 내지 않게) */
export function parseFibers(raw: string | null | undefined): string[] {
  return [...new Set((raw ?? '').split(',').map((x) => x.trim().toLowerCase()).filter((x) => FIBERS.includes(x)))];
}

/**
 * 비로그인 레일 안내 (Codex 8차 B7 · 사양 §26.3 기본안) — 제조사 · 재고 조건은 로그인한 뒤.
 * 「재고 보유」 체크와 제조사 묶음 자리에 한 줄로 둔다(로그인 단추는 상단바 · 결과 머리 안내가 맡는다 — 글 속 작은 링크를 두지 않는다)
 */
export function SupplyLockedNote() {
  return (
    <fieldset className="facet">
      <legend>재고 · 제조사</legend>
      <p className="facet-note supply-note"><Icon name="lock" size={14} /><span>로그인하면 재고 · 제조사 조건을 쓸 수 있습니다.</span></p>
    </fieldset>
  );
}

export function MaterialFilter({ entries, picked, multi, onChange }: {
  entries: FacetCount[];
  picked: string[];
  multi: boolean;
  onChange: (next: string[]) => void;
}) {
  // 고른 섬유는 0건이어도 남긴다(끌 수 있게)
  const list = [...entries];
  for (const p of picked) if (!list.some((e) => e.value === p)) list.unshift({ value: p, count: 0 });
  if (!list.length) return null;
  const toggle = (v: string) => {
    const on = picked.includes(v);
    onChange(on ? picked.filter((x) => x !== v) : multi ? [...picked, v] : [v]);
  };
  return (
    <fieldset className="facet facet-fibers">
      <legend>소재</legend>
      <div className="fiber-chips">
        {list.map((e) => {
          const on = picked.includes(e.value);
          return (
            <button type="button" key={e.value} className={on ? 'fiber-chip on' : 'fiber-chip'} aria-pressed={on}
                    onClick={() => toggle(e.value)}>
              {on && <Icon name="check" size={14} />}
              {FIBER_KO[e.value] ?? '기타'}
              <span className="fiber-n">{e.count.toLocaleString()}<span className="sr-only">건</span></span>
            </button>
          );
        })}
      </div>
      <p className="facet-note">
        {multi ? (picked.length > 1 ? '고른 섬유가 모두 든 원단만 보입니다.' : '여럿 고르면 모두 든 원단만 보입니다.')
          : '혼용률에 그 섬유가 적힌 원단만 보입니다.'}
      </p>
    </fieldset>
  );
}

